module.exports = __webpack_public_path__ + "static/log-axis-eee5d5eb7ec76d705e06e386392cfa39.png";